import { apiClient } from "./client";

export const getProfile = () => apiClient.get("/agents/profile").then((r) => r.data);
export const updateProfile = (data) => apiClient.put("/agents/profile", data).then((r) => r.data);
